/* AquaPet — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.ap-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ap-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ap-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Galería del producto ---------- */
  function initGallery() {
    var gal = document.querySelector('[data-ap-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-ap-gallery-main] img');
    var thumbs = gal.querySelectorAll('[data-ap-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (main && full) { main.src = full; }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    var items = document.querySelectorAll('.ap-faq__item');
    items.forEach(function (item) {
      var q = item.querySelector('.ap-faq__q');
      var a = item.querySelector('.ap-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        if (open) { item.classList.remove('is-open'); a.style.maxHeight = null; }
        else { item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* ---------- Producto: variantes + combos ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v;
  }

  function initProduct() {
    var root = document.querySelector('[data-ap-product]');
    if (!root) return;

    var dataEl = root.querySelector('[data-ap-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-ap-variant-id]');
    var qtyInput = root.querySelector('[data-ap-qty]');
    var addBtn = root.querySelector('[data-ap-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-ap-add-label]') : null;

    var colorBtns = root.querySelectorAll('[data-ap-color]');
    var sizeBtns = root.querySelectorAll('[data-ap-size]');
    var combos = root.querySelectorAll('[data-ap-combo]');

    var discPct = parseFloat(root.getAttribute('data-disc-pct')) || 0;
    var discFrom = parseInt(root.getAttribute('data-disc-from'), 10) || 0;
    function comboTotal(unit, q) {
      var full = unit * q;
      if (discPct > 0 && discFrom > 0 && q >= discFrom) {
        // Shopify aplica el descuento redondeando hacia abajo el importe descontado
        return full - Math.floor(full * discPct / 100);
      }
      return full;
    }

    var state = {
      color: colorBtns.length ? colorBtns[0].getAttribute('data-ap-color') : null,
      size: sizeBtns.length ? sizeBtns[0].getAttribute('data-ap-size') : null,
      qty: 2
    };

    function currentVariant() {
      return variants.find(function (v) {
        var okC = state.color == null || v.color === state.color;
        var okS = state.size == null || v.size === state.size;
        return okC && okS;
      }) || variants[0];
    }

    function paintSwatches(btns, key) {
      btns.forEach(function (b) {
        var val = b.getAttribute('data-ap-' + key);
        b.classList.toggle('is-active', val === state[key]);
      });
    }

    function updateCombos(v) {
      var unit = v ? v.price : 0;
      var cmpUnit = (v && v.compare_at && v.compare_at > unit) ? v.compare_at : unit;
      combos.forEach(function (c) {
        var q = parseInt(c.getAttribute('data-ap-combo'), 10) || 1;
        var ref = cmpUnit * q;                 // precio de referencia (tachado)
        var total = comboTotal(unit, q);       // precio real con descuento por cantidad
        var now = c.querySelector('[data-ap-combo-now]');
        var was = c.querySelector('[data-ap-combo-was]');
        var pct = c.querySelector('[data-ap-combo-pct]');
        if (now) now.textContent = money(total);
        if (was) {
          if (ref > total) { was.textContent = money(ref); was.style.display = ''; }
          else { was.style.display = 'none'; }
        }
        if (pct) {
          var p = ref > total ? Math.round((ref - total) / ref * 100) : 0;
          if (p > 0) { pct.textContent = 'AHORRA ' + p + '%'; pct.classList.add('is-on'); }
          else { pct.textContent = ''; pct.classList.remove('is-on'); }
        }
        c.classList.toggle('is-selected', q === state.qty);
      });
    }

    function update() {
      var v = currentVariant();
      paintSwatches(colorBtns, 'color');
      paintSwatches(sizeBtns, 'size');

      var unit = v ? v.price : 0;
      updateCombos(v);

      if (idInput && v) idInput.value = v.id;
      if (qtyInput) qtyInput.value = state.qty;

      var available = v && v.available;
      if (addBtn) {
        addBtn.disabled = !available;
        if (addLabel) {
          addLabel.textContent = available
            ? (root.getAttribute('data-add-text') || 'Añadir al carrito') + ' · ' + money(comboTotal(unit, state.qty))
            : 'Agotado';
        }
      }
    }

    colorBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.color = b.getAttribute('data-ap-color'); update(); });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.size = b.getAttribute('data-ap-size'); update(); });
    });
    combos.forEach(function (c) {
      c.addEventListener('click', function () { state.qty = parseInt(c.getAttribute('data-ap-combo'), 10) || 1; update(); });
    });

    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initGallery();
    initFaq();
    initProduct();
  });
})();
